const s = 1000;
const m = 60000;
const h = 3600000;

function unfuck(val) {
  return val.toString().padStart(2, "0");
}

export default function Countdown(props) {
  const timeLeft = props.t;

  // if countdown finishes
  if (timeLeft <= 0) {
    return (
      <h1 id="countdown">
        Endwalker is out now!
      </h1>
    );
  }

  const hLeft = unfuck(Math.trunc(timeLeft / h));
  const mLeft = unfuck(Math.trunc((timeLeft % h) / m));
  const sLeft = unfuck(Math.trunc((timeLeft % m) / s));

  const countdown = `${hLeft}:${mLeft}:${sLeft}`;

  return (
    <h1 id="countdown">
      Endwalker releases in <br />
      {countdown}
    </h1>
  );
}
